import React, { useEffect, useState } from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => {
  
  const [position, setPosition] = useState(0);


  function onScroll() {
    setPosition(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return ()=> {
      window.removeEventListener("scroll", onScroll);
    }
  }, [])
  
  

  return (
    <div className="app__aboutus app__bg flex__center section__padding" id="about">

      <div className="app__aboutus-content flex__center">
        <div className="app__aboutus-content_about">
          <h1 className='headtext__italiana'>About Us</h1>
          <img src={images.leaf} alt="about_leaf" className="leaf__img" />
          <p className="p__opensans">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
          <button type="button" className="custom__button">Know More</button>
        </div>

        <div className="app__aboutus-content_logo">
          <img src={images.logo} style={{opacity:(position - 500) / 300 }} alt="about_logo"/>
        </div>

        <div className="app__aboutus-content_history">
          <h1 className='headtext__italiana'>Our History</h1>
          <img src={images.leaf} alt="about_leaf" className="leaf__img" />
          <p className="p__opensans">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
          <button type="button" className="custom__button">Know More</button>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
